






























import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { DataApi } from '../models/Add.model';
import { fetchAdd } from '../fetchAdd';

@Component({ components: { GridComponent: AgGridVue } })
export default class TabDetalle extends Vue {
  @Prop({ required: true, default: null }) data!: DataApi;

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  quickSearch: string = '';
  loading: boolean = false;
  listData: any[] = [];

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 5,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.listData = await this.getTabEquipos();
    this.gridApi.setRowData(this.listData);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid(): ColDef[] {
    const cols = [
      { id: 'serie_equipo', field: 'Serie Equipo' },
      { id: 'tipoeqname', field: 'Tipo Equipo' },
      { id: 'simserienumero', field: 'SIM' },
      { id: 'fecha_despacho', field: 'Fecha Despacho' },
      { id: 'despachado_por', field: 'Despachado Por' },
      { id: 'movinumero', field: 'Nro. Movimiento' },
      { id: 'informado_crm', field: 'Informado CRM' },
      { id: 'glosa_crm', field: 'Glosa CRM' },
    ];

    return cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: 220,
      minWidth: 100,
    }));
  }

  async getTabEquipos() {
    this.loading = true;
    this.loadingService.showLoading();
    const self = this;

    return await fetchAdd({
      endpoint: 'get_detalle_dispositivos',
      body: {
        tag: 'detalle',
        id_add: this.data.id,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        return [...LISTA];
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { timeout: 3500 });
          return [];
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { timeout: 3500 }
          );
          return [];
        }
      })
      .finally(() => {
        self.loading = false;
        self.loadingService.hideLoading();
      });
  }
}
